<template>
    <div class="c-o-request-section no-print">
        <div class="c-o-request-section__inner c-o-request-section__inner--centered">
            <div class="c-o-request-section__main c-o-request-section__main--large" >
            <p>{{text}}</p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props:['text']
}
</script>


// WEBPACK FOOTER //
// src/views/components/atoms/SectionNoticeBox.vue